export default __webpack_public_path__ + "media/images/backgrounds/extended-mud-splats-573977aec96dd4a4d364a05ee881eb0b.svg";